// extracted by mini-css-extract-plugin
export default {"Care":"Care_Care__xIfUK"};